import React, { useEffect } from "react";
import { getLoggedUser } from './../../../apis/requests';
import { setUser, setUserLoggedStatus } from "../../redux/reducer";
import store from "../../redux/store";
const Background = () => {
    useEffect(() => {
        checkLoginStatus();
    }, []);
    const checkLoginStatus = async () => {
        try {
            const res = await getLoggedUser();
            if (res.data === undefined) {
                store.dispatch(setUserLoggedStatus(false));
            }
            else {
                store.dispatch(setUserLoggedStatus(true));
                store.dispatch(setUser(res.data.user));
            }
        } catch (error) {
            console.log(error);
            store.dispatch(setUserLoggedStatus(false));
        }
    }
    return (
        <>
        </>
    );
}
export default Background;